<template>
  <div class="page"
       v-bind:class="{
          'page--overlay' : initialData.overlayMenu,
          'page--auth-overlay' : isActiveOverlayLogin
       }">

    <Header></Header>

    <div class="instr-wrap">

      <div class="instr-section">
        <div class="instr-l-title">
          Документация
        </div>
        <label class="instr-search-field">
          <input type="text" placeholder="Введите ключевые слова" v-model="searchField">
        </label>
        <div class="instr-docs">
          <a class="instr-docs_item"
             v-bind:href="doc.file"
             v-for="(doc, docIndex) in filterDocuments"
             target="_blank"
             v-bind:key="docIndex">
            <div class="instr-docs_name">
              {{doc.title}}
            </div>
            <div class="instr-docs_category">
              {{doc.text}}
            </div>
          </a>
        </div>
        <div class="instr-search-none-res" v-if="!filterDocuments.length">
          Нет результата по заданным параметрам
        </div>
      </div>

      <Footer></Footer>
    </div>

  </div>
</template>

<script>
import Header from '@/components/Initial/Header.vue'
import Footer from '@/components/Initial/Footer.vue'

import { HTTP_COMM } from '@/main'

export default {
  name: "Docs",
  data(){
    return{
      searchField : '',
      documents : []
    }
  },
  mounted() {
    if( this.initialPage ){
      this.$store.dispatch('toggleInitialPage');
    }

    HTTP_COMM.get('/content/v1/documents/')
        .then( response => {
          this.documents = response.data.results
        })
        .catch( error => {
          this.$store.dispatch('errorResponse', error );
        });
  },
  computed : {
    filterDocuments : function (){
      let docs = [...this.documents];
      let wrd = this.searchField.toLowerCase().replace(/\s/g,'');

      return docs.filter( a => {
        let b = a.title.toLowerCase().replace(/\s/g,'');
        let c = a.text.toLowerCase().replace(/\s/g,'');
        return (b.indexOf( wrd ) > -1) || (c.indexOf( wrd ) > -1)
      });
    },
    initialPage() {
      return this.$store.state.initialPage;
    },
    initialData : function (){
      return this.$store.state.initial
    },
    isActiveOverlayLogin(){
      return this.$store.state.panels.login.status
    },
  },
  components: {
    Header,
    Footer
  },
}
</script>